import { isString, parseDateWithFormatDayMonthYear } from '../common';

export class EmploymentPeriod {
    /** @type {Date | null} */
    startDate: Date | null = null;

    /** @type {Date | null} */
    endDate: Date | null = null; // Friday of the week


    /** @type {number} */
    contractedHours: number = 40;

    /**
     * Create a new assignment demand
     * @param {Object} param0 The assignment demand parameters
     * @param {any} param0.startDate The start date of the demand
     * @param {any} param0.endDate The end date of the demand
     * @param {number | undefined} param0.contractedHours The working contract weekly hours
     */
    constructor(startDate: Date | string | null, endDate: Date | string | null, contractedHours: number) {

        if (startDate && typeof startDate === 'string') {
            this.startDate = this.parseToDate(startDate);
        } else if (startDate instanceof Date) {
            this.startDate = startDate;
        }

        if (endDate && typeof endDate === 'string') {
            this.endDate = this.parseToDate(endDate);
        } else if (endDate instanceof Date) {
            this.endDate = endDate;
        }

        if (contractedHours)
            this.contractedHours = contractedHours;
    }

    /**
     * @return {Date}
     */
    parseToDate(d: string | Date): Date {
        if (d instanceof Date) return d;

        return isString(d)
            ? parseDateWithFormatDayMonthYear(d)
            : new Date(d);
    }

    /**
     * @param {Date} d
     * @return {boolean}
     */
    isInEmploymentPeriod(d: Date): boolean {
        return this.startDate != null && this.startDate <= d && (this.endDate == null || d <= this.endDate);
    }
}
